module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon-toast-警告.b195a.png";